import { useMutation } from 'react-query'
import { deleteAPI } from 'framework/api/http'

interface DeleteEmailAlertGroupInterface {
  partnerId?: string
  serviceName?: string
}

export const useDeleteEmailAlertGroup = () => {
  const mutate = useMutation(
    ({ partnerId, serviceName }: DeleteEmailAlertGroupInterface) => {
      return deleteAPI(
        `/NotificationRecipientGroup/${partnerId}?serviceName=${encodeURIComponent(
          serviceName ?? '',
        )}`,
      )
    },
  )

  return mutate
}

export default useDeleteEmailAlertGroup
